<div class="flex flex-col items-center sm:flex-row justify-center gap-8 py-12">
  <div class="max-w-[400px]">
    <img
      src="assets/images/dp/uebergreifende_fehlerdarstellung.svg"
      alt="Daten nicht geladen"
    />
  </div>
  <div class="flex">
    <div class="flex flex-col justify-center gap-4">
      <h3 class="heading-2-sans font-medium">Interner Serverfehler</h3>
      <p>
        Die Downloads können aktuell nicht geladen werden.
        <br />
        Bitte versuchen Sie es in ein paar Minuten erneut.
      </p>
      <p class="pt-2">
        <button mat-button color="primary" (click)="onReloadClick.emit()">
          Seite neu laden
        </button>
      </p>
    </div>
  </div>
</div>
